import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ISupercargoDetail {
    id?: string,
    prefix?: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    suffixNum?: number,
    settingType? : string,
    isYear?: number,
    isMonth?: number,
    isDate?: number,
    style? : string,
    note? : string,
    orderNum?: number,
    traceId?: string,
    deleteFlag?: number,
    createTime? : string,
    updateTime? : string,
    createUser? : string,
    updateUser? : string,
    [key: string]: any
}
//新增
export interface ISupercargoInsert {
    "prefix"?:string,   // "ad reprehenderit magna in",
    "suffixNum"?:number,   // 22,
    "settingType"?:string,   // "CALCULATE",
    "isYear"?:number,   // 55,
    "isMonth"?:number,   // 59,
    "isDate"?:number,   // 20180911,
    "note"?:string,   // "veniam sint laborum tempor",
    "style"?:string,   // "incididunt"
}

//编辑
export interface ISupercargoUpdate extends ISupercargoInsert {
    id?: string,
}
//搜索条件
export interface ISupercargoSearchFields {
    startTime?:string
    endTime?:string
    [key:string]:any
}

export interface ISupercargoSearch
    extends ISupercargoSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch
    extends ISupercargoSearchFields, ISearchPage {
}



class SupercargoService {
    async page(searchVo: ISupercargoSearch, config: object = {}) {
        const apiUrl = "/threeInspection/base/driver/list";
        return await httpRequest.post<IPage<ISupercargoDetail>>(apiUrl, searchVo, config);
    }       
    async insert(searchVo: ISupercargoSearchFields) {
        const apiUrl = "/threeInspection/base/driver/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }    
    async edit(searchVo: ISupercargoSearchFields) {
        const apiUrl = "/threeInspection/base/driver/update";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async onDelete(searchVo: ISupercargoSearchFields) {
        const apiUrl = "/threeInspection/base/driver/delete";
        return await httpRequest.post<any>(apiUrl, searchVo);
    } 
    async one(searchVo: ISupercargoSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/page";
        return await httpRequest.post<IPage<ISupercargoDetail>>(apiUrl, searchVo);
    }    
    async orderLogs(searchVo: ISupercargoSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/progress_log/list";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }  
    async getSupercargoImg(updateVo: ISupercargoUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getImageClassifyList(updateVo: ISupercargoUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
    async downloadMB() {
        const appPageUrl = '/threeInspection/base/driver/downloadTpl'
        return await httpRequest.getFile(appPageUrl)
    }
}

export const supercargoService = new SupercargoService();
